import React  from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../assets/icons/Icon.svg';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom




function GeospatialDataGovernance() {
  const { t } = useTranslation();
  

  return (
    <div class="digital-twin-page">
      <div className="data-governance-card">
  <div className="data-governance-card-image">
    <img src={Icon} alt="Icon"/>
  </div>
  <div className="data-governance-card-content">
    <h3 className="data-governance-card-title" data-key="framework_title">{t('framework_title')}</h3>
    <p className="data-governance-card-description" data-key="framework_description">{t('framework_description')}</p>
    <div className="data-governance-card-footer">
      <span></span>
      <a href={t('framework_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
    </div>
  </div>
</div>
    
     {/* <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> <h3 class="data-governance-card-title" data-key="framework_title">  {t('framework_title')} </h3>
        <p class="data-governance-card-description" data-key="framework_description">  {t('framework_description')} </p> 
        <div class="data-governance-card-footer">
          <span></span><Link className="nav-link" to="/Framework"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link>
          
      </div>
      </div>
    </div> */}
    <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> <h3 class="data-governance-card-title" data-key="policies_title"> {t('policies_title')}</h3>
        <p class="data-governance-card-description" data-key="policies_description"> {t('policies_description')}</p> 
        <div class="data-governance-card-footer">
        <span></span>
        <a href={t('policies_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
      </div>
    </div>

    {/*<div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> <h3 class="data-governance-card-title" data-key="policies_title"> {t('policies_title')}</h3>
        <p class="data-governance-card-description" data-key="policies_description"> {t('policies_description')}</p> 
        <div class="data-governance-card-footer">
        <span></span><Link className="nav-link" to="/Policies"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link>
        </div>
      </div>
    </div> */}
    <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> <h3 class="data-governance-card-title" data-key="standards_title"> {t('standards_title')} </h3>
        <p class="data-governance-card-description" data-key="standards_description"> {t('standards_description')}</p> 
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('standards_title')} </p> 
        <a href={t('standards_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
       {/*  <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('standard_link_name')} </p> 
        <a href={t('standard_link_prd')} target="_blank" rel="noopener noreferrer">
        <button className="data-governance-card-link" id="readMoreBtn">{t('discover')}</button>
      </a>
        </div>*/}
       
      </div>
    </div>
    {/* National Geospatial Foundation Theme Specifications */}
    <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> <h3 class="data-governance-card-title" data-key="standards_title"> {t('Specifications_title')} </h3>
        <p class="data-governance-card-description" data-key="standards_description"> {t('Specifications_description')}</p> 
        
       {/* <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('Specifications_PDF_name')} </p> 
       
        <Link className="nav-link" to="/Specifications" id="terms_of_use">
                  
        <button className="data-governance-card-link" id="readMoreBtn" >{t('preview')}</button></Link>
      
              </div> */}
              <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('Specifications_link_name')} </p> 
        <a href={t('Specifications_link_prd')} target="_blank" rel="noopener noreferrer">
        <button className="data-governance-card-link" id="readMoreBtn">{t('wasif')}</button>
      </a>
              </div>
       
      </div>
    </div>
     {/*  */}
   
    <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> 
          <h3 class="data-governance-card-title" data-key="data_model_title"> {t('data_model_title')} </h3>
        <p class="data-governance-card-description"data-key="framework_description"> {t('framework_description')} </p> 
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('NationalGeospatialModel')} </p> 
        <a href={t('NationalGeospatialModel_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('NationalGeospatialMetadataProfile')} </p> 
        <a href={t('NationalGeospatialMetadataProfile_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('NationalFeatureConceptDictionary')} </p> 
        <a href={t('NationalFeatureConceptDictionary_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
           </div>
      </div>
      </div>
      <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> 
          <h3 class="data-governance-card-title" data-key="data_model_title"> {t('geospatial_infomation_unit')} </h3>
        <p class="data-governance-card-description"data-key="framework_description"> {t('geospatial_infomation_unit_description')} </p> 
        <div class="data-governance-card-footer">
        <span></span>
        <a href={t('geospatial_infomation_unit_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
          
      </div>
      </div>
      </div>

      {/* */}
      <div class="data-governance-card">
      <div class="data-governance-card-image">
        <img src={Icon} alt="Icon"/></div>
        <div class="data-governance-card-content"> 
          <h3 class="data-governance-card-title" data-key="data_model_title"> {t('technical_guideline')} </h3>
        <p class="data-governance-card-description"data-key="framework_description"> {t('technical_guideline_description')} </p> 
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('aerial_surveying_technical_guideline')} </p> 
        <a href={t('aerial_surveying_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('cartography_technical_guideline')} </p> 
        <a href={t('cartography_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
        </div>
        <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('geodesy_technical_guideline')} </p> 
        <a href={t('geodesy_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
           </div>
           <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('hydrography_technical_guideline')} </p> 
        <a href={t('hydrography_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
           </div>
           <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('land_survey_technical_guideline')} </p> 
        <a href={t('land_survey_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
           </div>

           <div class="data-governance-card-footer">
        <p class="data-governance-card-description"data-key="framework_description"> {t('remote_sensing_technical_guideline')} </p> 
        <a href={t('remote_sensing_pdf')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a>
           </div>
      </div>
      </div>
      
      
      </div>
  );
}

export default GeospatialDataGovernance;
